export function getContrastColorFromRGBA(r: number, g: number, b: number, a = 1): string {
  const blendedR = Math.round((1 - a) * 0 + a * r);
  const blendedG = Math.round((1 - a) * 0 + a * g);
  const blendedB = Math.round((1 - a) * 0 + a * b);

  const yiq = (blendedR * 299 + blendedG * 587 + blendedB * 114) / 1000;
  return yiq >= 128 ? "#000000" : "#FFFFFF";
}


export function parseRGBA(color: string) {
  let r = 0, g = 0, b = 0, a = 1;

  if (color.startsWith("rgb")) {
    const match = color.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*([\d.]+))?\)/);
    if (match) {
      r = parseInt(match[1], 10);
      g = parseInt(match[2], 10);
      b = parseInt(match[3], 10);
      a = match[4] !== undefined ? parseFloat(match[4]) : 1;
    }
  } else {
    const hex = color.replace("#", "");
    r = parseInt(hex.substring(0, 2), 16);
    g = parseInt(hex.substring(2, 4), 16);
    b = parseInt(hex.substring(4, 6), 16);
  }

  return { r, g, b, a };
}